import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";

import { UserSummaryConfigService } from "../user-summary/user-summary.config";

@Injectable({
	providedIn: "root",
})
export class BonusGuard implements CanActivate {
	constructor(private userSummaryConfigService: UserSummaryConfigService) {}

	canActivate(): Observable<boolean> {
		return this.userSummaryConfigService.getBonusVisible$().pipe(ignoreNil());
	}
}
